<template>
  <div class="mt-3 pb-4 mb-4 font-jumper">
    <b-container
      fluid
      id="work-docs-container"
      class="work-docs pt-4 col-12"
    >
      <b-row>
        <b-col class="ml-0 profile-input-container" cols="12">
          <div class="employee-layout">
            <section
              class="employee-section-card"
              aria-label="Munkaügyi dokumentumok"
            >
              <header class="employee-section-header">
                <h2
                  id="work-docs-heading"
                  class="employee-section-title d-none d-md-block"
                >
                  Munkaügyi dokumentumok
                </h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="work-docs-panel"
                  :aria-expanded="String(workDocsOpen)"
                  @click="workDocsOpen = !workDocsOpen"
                >
                  <span>Munkaügyi dokumentumok</span>
                  <b-icon
                    :icon="workDocsOpen ? 'chevron-up' : 'chevron-down'"
                    aria-hidden="true"
                  ></b-icon>
                </button>
              </header>

              <b-collapse
                id="work-docs-panel"
                v-model="workDocsOpen"
                class="employee-section-body"
              >
                <div class="employee-form-actions">
                  <BaseButton
                    variant="primary"
                    label="Új hozzáadása"
                    @click="goToFileUpload('WAGE', userId)"
                  />
                </div>

                <div class="employee-table-wrapper">
                  <b-table
                    class="employee-table"
                    responsive
                    striped
                    hover
                    primary-key="id"
                    :items="resources"
                    :fields="config.tableFields"
                  >
                    <template #cell(name)="data">
                      {{ data.item.name }}
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </section>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Api from "api-client";
import BaseButton from "@/components/BaseButton.vue";

export default {
  name: "WorkDocs",

  components: { BaseButton },

  props: {
    userName: {
      type: String,
    },
    userId: {
      type: Number
    }
  },
  data() {
    return {
      config: {
        tableFields: [
          {
            key: 'name',
            label: 'Fájl neve'
          },
        ]
      },

      workDocsOpen: !this.isMobile(),

      resources: []
    }
  },
  methods: {
    isMobile() {
      return window.innerWidth <= 768;
    },

    goToFileUpload(resourceType, employeeId) {
      this.$router.push({
        path: "/app/employee/edit/"+employeeId+"/fileUpload",
        query: {resourceType, employeeId},
      });
    },
  },

  mounted() {
    Api.getEmployeeResources(this.userId)
        .then((resp) => {
          this.resources = resp.data
        })
        .catch(() => {
          this.$toast.error({
            title: "Hiba",
            message: "Hiba",
          });
        });
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.hidden {
  display: none !important;
}

#work-docs-container.work-docs {
  color: #252734;
  padding-left: 0;
  padding-right: 0;
}

.employee-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.employee-section-card {
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 20px 40px rgba(37, 39, 52, 0.08);
  padding: 28px;
}

.employee-section-header {
  margin-bottom: 18px;
}

.employee-section-title {
  color: #252734;
  font-family: JumperBold;
  font-size: 24px;
  line-height: 1.2;
  margin: 0;
}

.employee-section-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: flex;
  font-family: JumperBold;
  font-size: 22px;
  justify-content: space-between;
  padding: 0;
  text-align: left;
  width: 100%;
}

.employee-section-toggle:focus {
  border-radius: 16px;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}

.employee-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-bottom: 18px;
}

.employee-table-wrapper {
  border-radius: 24px;
  overflow: hidden;
}

.employee-table-wrapper ::v-deep table {
  margin-bottom: 0;
}

.employee-table-wrapper ::v-deep thead th {
  border-bottom: 1px solid #AEBFC7;
  border-top: 0;
  color: #252734;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  vertical-align: middle;
  white-space: nowrap;
}

.employee-table-wrapper ::v-deep tbody td {
  border-top: 0;
  color: #252734;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  vertical-align: middle;
}

/* A hosszú fájlnevek teljes egészében megjelennek: tördelnek, nem csonkolódnak. */
.employee-table-wrapper ::v-deep tbody td {
  overflow-wrap: anywhere;
  text-overflow: clip;
  white-space: normal;
  word-break: break-word;
}

.employee-table-wrapper ::v-deep tbody tr:not(:last-child) td {
  border-bottom: 1px solid rgba(174, 191, 199, 0.45);
}

.employee-table-wrapper ::v-deep tbody tr.table-striped,
.employee-table-wrapper ::v-deep tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.55);
}

#work-docs-container.work-docs .row {
  margin-left: -8px;
  margin-right: -8px;
}

#work-docs-container.work-docs .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

#work-docs-container.work-docs .btn-light {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 18px rgba(37, 39, 52, 0.08);
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

#work-docs-container.work-docs .text-danger {
  color: #9f1d1d !important;
  font-size: 12px;
}

@media (min-width: 769px) {
  .employee-section-body.collapse:not(.show) {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }
}

@media (max-width: 768px) {
  #work-docs-container.work-docs {
    padding-top: 16px !important;
  }

  .employee-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .employee-section-card {
    border-radius: 28px;
    padding: 20px;
  }

  .employee-form-actions {
    justify-content: flex-start;
  }
}
</style>
